import {
  Button,
  type ButtonProps,
  type ComponentWithAs,
  forwardRef,
  Text,
} from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";

export const MoreNavItemsButton: ComponentWithAs<
  "button",
  Omit<ButtonProps, "children">
> = forwardRef((props, ref) => {
  return (
    <Button
      ref={ref}
      pos="relative"
      alignItems="center"
      justifyContent="start"
      flexDir="column"
      display="flex"
      w="20"
      h="full"
      color="grey.800"
      role="group"
      variant="unstyled"
      {...props}
    >
      <Icon name="dots-horizontal" w="4" h="4" />
      <Text mt="4" fontSize="xs" hideFrom="xl">
        <Trans>More</Trans>
      </Text>
    </Button>
  );
});
